export const QR_COLORS = ["#000000", "#1a1a2e", "#e5322d", "#0891b2", "#1a7a43", "#6366f1"];
export const QR_BACKGROUND_COLORS = ["#FFFFFF", "#FFF0F0", "#F8F9FC", "#EEF7FF", "#F0FDF4"];
export const DEFAULT_QR_COLOR = "#000000";
export const DEFAULT_QR_SIZE = 250;

export const QR_SIZES = [
  { label: "Small", value: 180 },
  { label: "Medium", value: DEFAULT_QR_SIZE },
  { label: "Large", value: 320 },
];

export const QR_CONFIGS = {
  Website: {
    activeType: "Website QR",
    title: "Website QR Code",
    subtitle: "Create a QR code that opens a website URL.",
    primaryLabel: "Website URL",
    primaryKey: "url",
    primaryPlaceholder: "https://example.com",
  },
  Text: {
    activeType: "Text QR",
    title: "Text QR Code",
    subtitle: "Create a QR code for rich text content.",
    descriptionLabel: "Text Content",
    descriptionKey: "text",
  },
  Location: {
    activeType: "Location QR",
    title: "Location QR Code",
    subtitle: "Create a QR code that opens a map or venue location.",
    primaryLabel: "Maps URL",
    primaryKey: "mapsUrl",
    primaryPlaceholder: "https://maps.google.com/?q=...",
    payloadFields: [
      { key: "venueName", label: "Venue Name", placeholder: "Bonoxi Store" },
      { key: "address", label: "Address", placeholder: "Delhi" },
    ],
  },
  Brand: {
    activeType: "Brand QR",
    title: "Brand QR Code",
    subtitle: "Create a branded website QR with an optional logo.",
    primaryLabel: "Website URL",
    primaryKey: "websiteUrl",
    primaryPlaceholder: "https://company.com",
    fileLabel: "Logo",
    fileKey: "logo",
    fileAccept: ".jpg,.jpeg,.png",
    payloadFields: [
      { key: "companyName", label: "Company Name", placeholder: "Bonoxi" },
    ],
  },
  Social: {
    activeType: "Social QR",
    title: "Social QR Code",
    subtitle: "Create a QR code for a social profile or video link.",
    primaryLabel: "Social URL",
    primaryKey: "socialUrl",
    primaryPlaceholder: "https://instagram.com/...",
    platformLabel: "Platform",
    platformOptions: ["Instagram", "Facebook", "LinkedIn", "YouTube", "X", "TikTok", "Vimeo", "Custom"],
  },
  File: {
    activeType: "File QR",
    title: "File QR Code",
    subtitle: "Upload a file and create a QR code that opens it.",
    fileLabel: "Upload File",
    fileKey: "file",
    fileAccept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.jpg,.jpeg,.png,.gif,.bmp,.webp",
    fileRequired: true,
  },
  vCard: {
    activeType: "vCard QR",
    title: "vCard QR Code",
    subtitle: "Create a digital business card QR.",
    payloadFields: [
      { key: "name", label: "Full Name", placeholder: "Pawan Kumar", required: true },
      { key: "mobile", label: "Mobile", placeholder: "+911234567890" },
      { key: "email", label: "Email", placeholder: "pawan@example.com" },
      { key: "companyName", label: "Company", placeholder: "Bonoxi" },
      { key: "designation", label: "Designation", placeholder: "Founder" },
      { key: "website", label: "Website", placeholder: "https://bonoxi.com" },
      { key: "address", label: "Address", placeholder: "Delhi" },
    ],
  },
  Product: {
    activeType: "Product QR",
    title: "Product QR Code",
    subtitle: "Create a QR code for a product or ecommerce page.",
    primaryLabel: "Product URL",
    primaryKey: "productUrl",
    primaryPlaceholder: "https://amazon.in/...",
    payloadFields: [
      { key: "sku", label: "SKU", placeholder: "ABC123" },
    ],
  },
  Message: {
    activeType: "Message QR",
    title: "Message QR Code",
    subtitle: "Create a QR code for an invitation, greeting, or announcement.",
    subjectLabel: "Subject",
    descriptionLabel: "Description",
    fileLabel: "Picture",
    fileKey: "file",
    fileAccept: ".jpg,.jpeg,.png",
    payloadFields: [
      { key: "eventDate", label: "Event Date", placeholder: "01-May-2026", type: "date" },
    ],
  },
};
